<template>
    <li>
        <SkyButton
            :key="group.url"
            :href="group.url"
            variant="text"
            v-bind="linkAttrs"
            :class="{ active: isActiveUrl }"
            data-test="group-link"
            class="child-link"
            :aria-label="ariaText"
            @click="clicked">
            <SkyText tag="span">
                {{ group.title }}
            </SkyText>
        </SkyButton>
    </li>
</template>

<script>
    import { GLOBAL_EVENTS, globalEventHandler } from "@eg_ui/src/utils/libs";

    import { SkyButton, SkyText } from "@skyline2/vue";

    export default {
        components: { SkyButton, SkyText },
        props: {
            group: { type: Object, default: () => {} },
            index: { type: Number, default: 0 },
            listLength: { type: Number, default: 0 },
        },
        emits: ["clicked"],
        computed: {
            ariaText() {
                return this.$formatMessage(
                    {
                        defaultMessage: 'My group "{title}": {index} out of {listLength}',
                        id: "whatsUp.leftColumnGroupLink.myGroup",
                    },
                    { index: this.index, listLength: this.listLength, title: this.group.title },
                );
            },
            isActiveUrl() {
                // Need to use "includes" because $route.path will have "/feed", "/members", etc appended to the end
                return this.$route.path.includes(this.group.url);
            },
            linkAttrs() {
                const attrs = {};

                if (this.isActiveUrl) {
                    attrs["aria-current"] = "page";
                }

                return attrs;
            },
        },
        methods: {
            clicked() {
                globalEventHandler.emit(GLOBAL_EVENTS.ANALYTICS.EVENT, {
                    event: "main_nav",
                    sub_type: "my_groups",
                });
                this.$emit("clicked");
            },
        },
    };
</script>
